'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListItems = exports.getQeId = exports.getTitle = exports.getSecondaryHeadline = exports.getBackgroundUrl = exports.getLinks = exports.getFeatureBreaker = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _dtmLinkAppend = require('acq-components/lib/utils/DTM/dtmLinkAppend');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _componentHelpers = require('../../utils/component-helpers');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addLinkNavParams = function addLinkNavParams(dtmInfo) {
  return function (link) {
    if (!link.url || !link.dtm || !link.dtm.eventAsset) {
      return link;
    }

    var navType = [_dtmConsts.DTM_CONSTS.defaultNavType, _dtmConsts.DTM_CONSTS.intLinkNavType].includes(link.dtm.eventAction) ? link.dtm.eventAction : _dtmConsts.DTM_CONSTS.defaultNavType;

    return (0, _extends3.default)({}, link, {
      url: (0, _dtmLinkAppend.appendLinkNav)(link.url, navType, dtmInfo.linkNavBase, dtmInfo.pageName, link.dtm.eventAsset)
    });
  };
};

var getFeatureBreaker = exports.getFeatureBreaker = function getFeatureBreaker(state) {
  return (0, _lodash2.default)(state.intlPage, 'cards[0].featureBreaker');
};

var getLinks = exports.getLinks = (0, _reselect.createSelector)([getFeatureBreaker, _common.dtmSelector], function (featureBreaker, dtm) {
  return ((0, _lodash2.default)(featureBreaker, 'links') || []).map(addLinkNavParams(dtm));
});

var getBackgroundUrl = exports.getBackgroundUrl = (0, _reselect.createSelector)(getFeatureBreaker, function (featureBreaker) {
  return (((0, _lodash2.default)(featureBreaker, 'assets') || [])[0] || {}).url || '';
});

var getSecondaryHeadline = exports.getSecondaryHeadline = (0, _reselect.createSelector)(getFeatureBreaker, function (featureBreaker) {
  return (0, _componentHelpers.concactDescStr)((0, _lodash2.default)(featureBreaker, 'desc') || []);
});

var getTitle = exports.getTitle = (0, _reselect.createSelector)(getFeatureBreaker, function (featureBreaker) {
  return (0, _lodash2.default)(featureBreaker, 'header') || '';
});

var getQeId = exports.getQeId = (0, _reselect.createSelector)(getFeatureBreaker, function (featureBreaker) {
  return (0, _lodash2.default)(featureBreaker, 'qeId') || undefined;
});

var getListItems = exports.getListItems = (0, _reselect.createSelector)(getFeatureBreaker, function (featureBreaker) {
  return ((0, _lodash2.default)(featureBreaker, 'content') || []).filter(function (item) {
    return !!item.desc;
  });
});